import { render, staticRenderFns } from "./OrderFormEdit.vue?vue&type=template&id=fec66daa&"
import script from "./OrderFormEdit.vue?vue&type=script&lang=ts&"
export * from "./OrderFormEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports